import { render, staticRenderFns } from "./DetallesLicitador.vue?vue&type=template&id=4ac5cc44&scoped=true&"
import script from "./DetallesLicitador.vue?vue&type=script&lang=js&"
export * from "./DetallesLicitador.vue?vue&type=script&lang=js&"
import style0 from "./DetallesLicitador.vue?vue&type=style&index=0&id=4ac5cc44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac5cc44",
  null
  
)

export default component.exports